import React from 'react';
import { List, Card, notification, Modal } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Meta from 'antd/lib/card/Meta';

import { IMemberDataObject, ISingleReservation, IWholeHallReservation, locale, t } from './MainApp';
import { NavLink } from 'react-router-dom';
import { IObject } from './App';

type TCancelWholeHallReservationResponse = {
    "success": boolean,
    "message": {
        "en": string,
        "bg": string,
    },
};

function padToTwo(x: number) {
    let result: string = '';
    if (x < 10) {
        result += '0';
    }
    result += x;
    return result;
}

function dateTimestampToString(dt: number): string {
    let d: Date = new Date(dt);
    let s: string = "";
    s += padToTwo(d.getDate()) + "." + padToTwo(d.getMonth() + 1) + "." + d.getFullYear() + " " + padToTwo(d.getHours()) + ":" + padToTwo(d.getMinutes()) + ":" + padToTwo(d.getSeconds());
    return s;
}

function guestsToFragment(guests: string[]) {
    return (
        <React.Fragment>
            {guests.map((guest, index) => {
                return (
                    <React.Fragment>
                        {(index + 1).toString() + "."}
                        {guest}
                        <br />
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
}

function guestsForWholeHallReservation(wholeHallReservation: IWholeHallReservation) {
    let guests: string[] = [];

    for (const reservation of wholeHallReservation.reservations) {
        for (const person of reservation.guests) {
            guests.push(person);
        }
    }

    let elems = [];
    for (let idx = 0; idx < guests.length; ++idx) {
        elems.push((
            <>
                {(idx + 1).toString() + "."}
                {guests[idx]}
                <br />
            </>
        ));
    }

    return elems;
}

type ReservationsProps = {
    locale: locale,
    objects: IObject[],
    membersdata: IMemberDataObject,
    reservations: ISingleReservation[],
    wholeHallReservations: IWholeHallReservation[],
    onDeleteReservation: () => void,
};

type ReservationsState = {
};

class Reservations extends React.Component<ReservationsProps, ReservationsState>
{
    state: ReservationsState = {
    };

    constructor(props: ReservationsProps) {
        super(props);

        this.cancelReservation = this.cancelReservation.bind(this);
        this.cancelWholeHallReservation = this.cancelWholeHallReservation.bind(this);
    }

    cancelReservation(reservation: ISingleReservation) {
        fetch(`${process.env.REACT_APP_API_PREFIX}/reservations/api/cancelreservation`, {
            method: 'post',
            body: JSON.stringify({
                'reservationId': reservation.id,
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((value) => {
            this.props.onDeleteReservation();
        }).catch((reason) => {
            notification.error({ message: 'Error canceling reservation', description: reason });
        });
    }

    cancelWholeHallReservation(reservation: IWholeHallReservation) {
        fetch(`${process.env.REACT_APP_API_PREFIX}/reservations/api/cancelwholehallreservation`, {
            method: 'post',
            body: JSON.stringify({
                'reservationId': reservation.id,
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response => response.json())
            .then((value: TCancelWholeHallReservationResponse) => {
                if (value.success === true) {
                    this.props.onDeleteReservation();
                } else {
                    Modal.error({
                        title: t(this.props.locale, 'wholeHallReservationCancelError'),
                        content: value.message[this.props.locale],
                    });
                }
            }).catch((reason) => {
                notification.error({ message: 'Error canceling reservation', description: reason });
            });
    }

    render() {

        return (
            <>
                <h4 className={'no-padding-left play-bold text-center'}>{t(this.props.locale, "currentReservations")}</h4>
                <List
                    locale={this.props.locale === 'en' ? { emptyText: t('en', "textnoreservations") } : { emptyText: t('bg', "textnoreservations") }}
                    grid={{ gutter: 8, column: 2 }}
                    dataSource={this.props.reservations}
                    renderItem={item => (
                        <React.Fragment>

                            <List.Item>
                                <Card
                                    actions={[
                                        item.status === 0 ?
                                            <NavLink to={"/editreservation/" + item.id.toString()} >
                                                <EditOutlined key="edit" />
                                            </NavLink> : <React.Fragment></React.Fragment>,
                                        item.status === 0 ? <DeleteOutlined key="delete" onClick={() => this.cancelReservation(item)} /> : <React.Fragment></React.Fragment>
                                    ]}>

                                    <Meta title={t(this.props.locale, "reservation") + ` #${item.id}`} description={
                                        <React.Fragment>
                                            <div>{t(this.props.locale, "object")}: {item.objectName}</div>
                                            <div>{t(this.props.locale, "hall")}: {item.hallName}</div>
                                            <div>{t(this.props.locale, "table")}: {item.tableName}</div>
                                            <div>{t(this.props.locale, "from")}: {dateTimestampToString(item.startDate)}</div>
                                            <div>{t(this.props.locale, "to")}: {dateTimestampToString(item.endDate)}</div>
                                            <div>{t(this.props.locale, "guests")} {guestsToFragment(item.guests)}</div>
                                        </React.Fragment>
                                    } />
                                </Card>
                            </List.Item>
                        </React.Fragment>
                    )}
                />

                <h4 className={'no-padding-left play-bold text-center'}>{t(this.props.locale, "currentwholehallreservations")}</h4>
                <List
                    locale={this.props.locale === 'en' ? { emptyText: t('en', "textnoreservations") } : { emptyText: t('bg', "textnoreservations") }}
                    grid={{ gutter: 8, column: 2 }}
                    dataSource={this.props.wholeHallReservations}
                    renderItem={wholeHallReservation => (
                        <>

                            <List.Item>
                                <Card
                                    actions={[
                                        wholeHallReservation.status === 0
                                            ? <><NavLink to={"/editwholereservation/" + wholeHallReservation.id.toString()} >
                                                <EditOutlined key="edit" />
                                            </NavLink><DeleteOutlined key="delete" onClick={() => this.cancelWholeHallReservation(wholeHallReservation)} /></>
                                            : <></>
                                    ]}>

                                    <Meta title={t(this.props.locale, "reservation") + ` #${wholeHallReservation.id}`} description={
                                        <React.Fragment>
                                            <div>{t(this.props.locale, "object")}: {wholeHallReservation.reservations[0].objectName}</div>
                                            <div>{t(this.props.locale, "hall")}: {wholeHallReservation.reservations[0].hallName}</div>
                                            <div>{t(this.props.locale, "from")}: {dateTimestampToString(wholeHallReservation.reservations[0].startDate)}</div>
                                            <div>{t(this.props.locale, "to")}: {dateTimestampToString(wholeHallReservation.reservations[0].endDate)}</div>
                                            <div>{t(this.props.locale, "guests")} <>{guestsForWholeHallReservation(wholeHallReservation)}</></div>
                                        </React.Fragment>
                                    } />
                                </Card>
                            </List.Item>
                        </>
                    )}
                />
            </>
        );
    }
}

export default Reservations;